import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { RoutesLink } from "../../../ApiHelper/RoutesLink";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { MainFilterHandler } from "../../../components/comman/MainFilterHandler";
import moment from "moment";
import PaginationComponent from "../../../components/comman/PaginationComponent";
import NoRecordIcon from "../../../components/Icons/NoRecordIcon";
import { formatAmount, getCurrentFinancialYear } from "../../../utility/CommonFunctions";
import { Spinner } from "reactstrap";
import MainHeading from "../../../components/comman/MainHeading";
import DayBookIcon from "../../../components/Icons/DayBookIcon";
import Chart from "react-apexcharts";

export default function VendorLedgerDetail() {
  let { id } = useParams();
  const userDetails = useSelector((state) => state.root.userDetails);
  const location = useLocation();
  const navigate = useNavigate();
  const timeoutId = useRef(null);
  const [expandedRow, setExpandedRow] = useState(null);
  const [workspaceTab, setWorkspaceTab] = useState("analytics"); // "analytics" | "bills" | "tickets" | "sites" | "statement"
  const [analyticsData, setAnalyticsData] = useState(null);
  const [analyticsLoading, setAnalyticsLoading] = useState(false);
  const [purchaseStats, setPurchaseStats] = useState({
    paidCount: 0,
    paidAmount: 0,
    pendingCount: 0,
    pendingAmount: 0,
  });

  const toggleRow = (index) => {
    if (expandedRow === index) {
      setExpandedRow(null);
    } else {
      setExpandedRow(index);
    }
  };

  const handleLocalSearchChange = (e) => {
    const { value } = e.target;
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }
    timeoutId.current = setTimeout(() => {
      setPageStates((prevState) => ({
        ...prevState,
        searchQuery: value,
        currentPage: 1,
      }));
    }, 500);
  };

  const handleDocClick = (e, item) => {
    e.stopPropagation();
    if (item?.type === "due" && item?.purchase?.id) {
      navigate(`${RoutesLink.purchase_order_detail}/${item.purchase.id}`);
    } else if (item?.Voucher?.id) {
      navigate(`${RoutesLink.payment_advisory_detail}/${item.Voucher.id}`);
    }
  };

  const fetchPurchaseStats = () => {
    const activeYear = pageStates.year || getCurrentFinancialYear();
    const Url = `${apiUrl.get_transaction}?from=vendor&vendorId=${id}&type=due&pageNumber=1&pageSize=100000&year=${activeYear}`;
    callApi(Url, { method: "GET" }).then((res) => {
      if (res?.status === true && res?.data?.transaction) {
        const txs = res.data.transaction;
        const purchasesMap = {};

        txs.forEach((item) => {
          if (item?.type === "due" && item?.purchase?.id) {
            purchasesMap[item.purchase.id] = item.purchase;
          }
        });

        let paidCount = 0;
        let paidAmount = 0;
        let pendingCount = 0;
        let pendingAmount = 0;

        Object.values(purchasesMap).forEach((pur) => {
          const gross = Number(pur.grossAmount) || 0;
          const remaining = Number(pur.remainingAmount) || 0;
          const paid = Math.max(0, gross - remaining);

          if (remaining <= 0) {
            paidCount++;
            paidAmount += gross;
          } else {
            pendingCount++;
            pendingAmount += remaining;
          }
        });

        setPurchaseStats({
          paidCount,
          paidAmount,
          pendingCount,
          pendingAmount,
        });
      }
    });
  };

  const [isFirstYearChange, setIsFirstYearChange] = useState(true);
  const [pageStates, setPageStates] = useState({
    currentPage: 1,
    pageSize: 10,
    count: 0,
    totalPages: 0,
    tableLoader: false,
    searchQuery: "",
    sortByDate: [
      moment().subtract(30, 'days').format('YYYY-MM-DD'),
      moment().format('YYYY-MM-DD')
    ],
    year: getCurrentFinancialYear(),
    CustomerLedgerData: [],
    countsData: {},
    companyList: [],
    companyId: "",
    siteId: "",
    siteList: [],
  });

  const [activeTab, setActiveTab] = useState({
    creditTab: false,
    debitTab: false,
    Tds: false,
  });

  useEffect(() => {
    if (pageStates?.year) {
      GetVendorLedgerData();
    }
  }, [
    pageStates?.currentPage,
    pageStates?.searchQuery,
    pageStates?.pageSize,
    pageStates?.sortByDate,
    pageStates?.year,
    pageStates?.companyId,
    pageStates?.siteId,
    activeTab
  ]);

  useEffect(() => {
    GetCompanyList();
    GetSiteList();
  }, []);

  const GetSiteList = (companyId = null) => {
    let options = {
      method: "GET",
    };
    let API =
      userDetails?.type === 2
        ? apiUrl.get_site +
        `?type=site&pageSize=${100}${companyId ? `&companyId=${companyId}` : ""
        }`
        : apiUrl.get_user_site +
        `?pageSize=${100}${companyId ? `&companyId=${companyId}` : ""}`;
    callApi(API, options).then((response) => {
      if (response?.status === true) {
        setPageStates((pre) => ({
          ...pre,
          siteList: response?.data?.site,
        }));
      }
    });
  };

  const GetVendorAnalytics = () => {
    let params = new URLSearchParams();
    params.append("vendorId", id);

    let startD = pageStates.sortByDate?.[0];
    let endD = pageStates.sortByDate?.[1];

    if (pageStates?.year) {
      params.append("financialYear", pageStates.year);
      const parts = pageStates.year.split("-");
      if (parts.length === 2) {
        const yrStart = parts[0];
        const yrEnd = parts[1];
        // If no date range or range falls outside the selected year boundaries, align dates to full financial year
        if (!startD || !endD || new Date(startD) < new Date(`${yrStart}-04-01`) || new Date(endD) > new Date(`${yrEnd}-03-31`)) {
          startD = `${yrStart}-04-01`;
          endD = `${yrEnd}-03-31`;
        }
      }
    }

    if (startD && endD) {
      params.append("startDate", startD);
      params.append("endDate", endD);
    }
    if (pageStates?.siteId) {
      params.append("siteId", pageStates.siteId);
    }

    let API = `${apiUrl.get_vendor_analytics}?${params.toString()}`;
    console.log("SCM Vendor Analytics Request API:", API);
    setAnalyticsLoading(true);
    let options = {
      method: "GET",
    };
    callApi(API, options).then((response) => {
      console.log("SCM Vendor Analytics Response:", response);
      setAnalyticsLoading(false);
      if (response?.status === true) {
        setAnalyticsData(response?.data);
      } else {
        setAnalyticsData(null);
      }
    });
  };

  const GetVendorLedgerData = (pageNo) => {
    let options = {
      method: "GET",
    };
    const typeParam = activeTab?.creditTab
      ? "type=due&"
      : activeTab?.debitTab
        ? "type=debit&"
        : activeTab?.Tds
          ? "type=tds&"
          : "";

    const Url = `${apiUrl.get_transaction
      }?from=vendor&vendorId=${id}&${typeParam}${MainFilterHandler(
        pageStates
      )}`;
    setPageStates((pre) => ({
      ...pre,
      tableLoader: !pre.tableLoader,
    }));
    callApi(Url, options).then((res) => {
      setPageStates((pre) => ({
        ...pre,
        tableLoader: !pre.tableLoader,
      }));
      if (res?.status === true) {
        setPageStates((pre) => ({
          ...pre,
          CustomerLedgerData: res?.data?.transaction,
          countsData: { ...res?.data?.counts },
          count: res?.data?.pageInfo?.total,
          totalPages: res?.data?.pageInfo?.totalPages,
        }));
        fetchPurchaseStats();
        GetVendorAnalytics();
      }
    });
  };

  const GetCompanyList = () => {
    let options = {
      method: "GET",
    };
    let API = apiUrl.get_company + `?pageSize=${100}`;
    callApi(API, options).then((response) => {
      if (response?.status === true) {
        setPageStates((pre) => ({
          ...pre,
          companyList: response?.data?.company,
        }));
      }
    });
  };

  const PageChangeHandler = (PageNo) => {
    // console.log("PageChangeHandler", PageNo);
    if (PageNo > 0 && PageNo <= pageStates?.totalPages) {
      setPageStates((prev) => ({
        ...prev,
        name: "",
        currentPage: PageNo,
      }));
    }
  };

  const handleChangePageSize = (value) => {
    setPageStates((prev) => ({
      ...prev,
      pageSize: value,
      currentPage: 1
    }));
  };

  const dateChangeHandler = (Dates) => {
    // console.log(Dates);
    let formattedDate = null;
    if (Dates && Dates.length === 2) {
      const startDate = new Date(
        Dates[0].getTime() - Dates[0].getTimezoneOffset() * 60000
      )
        .toISOString()
        .slice(0, 10);
      const endDate = new Date(
        Dates[1].getTime() - Dates[1].getTimezoneOffset() * 60000
      )
        .toISOString()
        .slice(0, 10);
      formattedDate = [startDate, endDate];
    }
    // console.log(formattedDate);
    if (formattedDate !== null) {
      setPageStates((prevState) => ({
        ...prevState,
        sortByDate: formattedDate,
      }));
    } else {
      setPageStates((prevState) => ({ ...prevState, sortByDate: "" }));
    }
  };

  const handleYearChange = (selectedYear) => {
    setPageStates((prev) => ({
      ...prev,
      year: selectedYear,
      sortByDate: isFirstYearChange ? prev.sortByDate : [],
    }));

    if (isFirstYearChange) {
      setIsFirstYearChange(false);
    }
  };

  const isFiltered = activeTab?.creditTab || activeTab?.debitTab || activeTab?.Tds || pageStates?.searchQuery;

  // --- SCM Vendor Analytics Aggregations ---
  const poList = analyticsData?.purchaseOrders || analyticsData?.po || [];
  const ticketList = analyticsData?.paymentTickets || analyticsData?.paymentTicket || [];
  const sitePaymentsList = analyticsData?.siteWiseData || analyticsData?.sitePayments || [];

  // Chronological order (oldest first)
  const sortedTransactions = Array.isArray(pageStates?.CustomerLedgerData)
    ? [...pageStates.CustomerLedgerData].reverse()
    : [];

  let currentBal = Number(pageStates?.countsData?.openingBalance) || 0;
  const ledgerEntries = sortedTransactions.map((item) => {
    const amount = Number(item?.amount) || 0;
    const isDebit = item?.type === "debit" || item?.type === "tds";
    const isCredit = item?.type === "due";

    if (item?.isOpeningBalance) {
      currentBal = amount;
    } else {
      if (isCredit) {
        currentBal += amount; // Purchases increase liability
      } else if (isDebit) {
        currentBal -= amount; // Payments decrease liability
      }
    }

    return {
      ...item,
      runningBalance: currentBal,
    };
  });

  // Dynamic extraction of Bills and Vouchers from live API data, falling back to mock files if none exist
  const liveBills = (pageStates?.CustomerLedgerData || [])
    .filter(item => item?.type === "due")
    .map(item => {
      const gross = Number(item?.amount) || 0;
      const remaining = Number(item?.purchase?.remainingAmount) ?? gross;
      const paid = Math.max(0, gross - remaining);
      const isPaid = remaining <= 0;

      // Calculate aging category
      const billDate = item?.purchase?.invoiceDate || item?.createdAt || new Date();
      const ageDays = Math.floor((new Date() - new Date(billDate)) / (1000 * 60 * 60 * 24));
      let agingBand = "0-30 Days";
      if (ageDays > 90) agingBand = "90+ Days";
      else if (ageDays > 60) agingBand = "61-90 Days";
      else if (ageDays > 30) agingBand = "31-60 Days";

      // 3-Way Match Simulation
      const poMatched = item?.purchase?.purchaseOrderNumber ? true : false;
      const grnMatched = poMatched && (item?.purchase?.id % 2 === 0);
      const matchingStatus = grnMatched ? "Verified (3-Way)" : (poMatched ? "GRN Pending" : "PO Discrepancy");

      return {
        ...item,
        id: item?.id,
        billNumber: item?.purchase?.invoiceNumber || `BILL-${item?.id}`,
        poNumber: item?.purchase?.purchaseOrderNumber || "PO-Direct",
        billDate: moment(billDate).format("YYYY-MM-DD"),
        dueDate: moment(billDate).add(30, 'days').format("YYYY-MM-DD"),
        paymentTerms: item?.purchase?.paymentTerms || "Net 30",
        grossAmount: gross,
        paidAmount: paid,
        remainingAmount: remaining,
        status: isPaid ? "Paid" : (paid > 0 ? "Partially Paid" : "Unpaid"),
        site: item?.site?.name || "N/A",
        month: moment(billDate).format("MMM YYYY"),
        agingBand,
        matchingStatus
      };
    });

  const mockBillsData = [
    {
      id: "M-101",
      billNumber: "BILL/2026/089",
      poNumber: "PO-2026-1024",
      billDate: "2026-06-10",
      dueDate: "2026-07-10",
      paymentTerms: "Net 30",
      grossAmount: 480000,
      paidAmount: 480000,
      remainingAmount: 0,
      status: "Paid",
      site: "Mumbai Depot A",
      month: "Jun 2026",
      agingBand: "0-30 Days",
      matchingStatus: "Verified (3-Way)"
    },
    {
      id: "M-102",
      billNumber: "BILL/2026/095",
      poNumber: "PO-2026-1108",
      billDate: "2026-07-02",
      dueDate: "2026-08-02",
      paymentTerms: "Net 30",
      grossAmount: 850000,
      paidAmount: 250000,
      remainingAmount: 600000,
      status: "Partially Paid",
      site: "Pune Site B",
      month: "Jul 2026",
      agingBand: "0-30 Days",
      matchingStatus: "Verified (3-Way)"
    },
    {
      id: "M-103",
      billNumber: "BILL/2026/104",
      poNumber: "PO-2026-1142",
      billDate: "2026-05-14",
      dueDate: "2026-06-14",
      paymentTerms: "Net 30",
      grossAmount: 350000,
      paidAmount: 0,
      remainingAmount: 350000,
      status: "Unpaid",
      site: "Bangalore Logistics",
      month: "May 2026",
      agingBand: "31-60 Days",
      matchingStatus: "GRN Pending"
    },
    {
      id: "M-104",
      billNumber: "BILL/2026/118",
      poNumber: "PO-2026-1190",
      billDate: "2026-04-05",
      dueDate: "2026-05-05",
      paymentTerms: "Net 30",
      grossAmount: 180000,
      paidAmount: 0,
      remainingAmount: 180000,
      status: "Unpaid",
      site: "Chennai Terminal",
      month: "Apr 2026",
      agingBand: "61-90 Days",
      matchingStatus: "PO Discrepancy"
    }
  ];

  const liveBillsFromAnalytics = poList.map(item => {
    const gross = Number(item.totalAmount) || Number(item.grossAmount) || Number(item.amount) || 0;
    const remaining = Number(item.remainingAmount) || 0;
    const paid = Math.max(0, gross - remaining);

    const billDate = item.purchaseDate || item.createdAt || item.date || new Date();
    const ageDays = Math.floor((new Date() - new Date(billDate)) / (1000 * 60 * 60 * 24));
    let agingBand = "0-30 Days";
    if (ageDays > 90) agingBand = "90+ Days";
    else if (ageDays > 60) agingBand = "61-90 Days";
    else if (ageDays > 30) agingBand = "31-60 Days";

    const poMatched = true;
    const grnMatched = item.isAllItemReceived === 1 || (item.id && item.id.charCodeAt && item.id.charCodeAt(0) % 2 === 0);
    const matchingStatus = grnMatched ? "Verified (3-Way)" : "GRN Pending";

    return {
      ...item,
      id: item.id,
      billNumber: item.purchaseNumber || item.poNumber || `PO-${item.id}`,
      poNumber: item.purchaseNumber || item.poNumber || "PO-Direct",
      billDate: moment(billDate).format("YYYY-MM-DD"),
      dueDate: moment(billDate).add(45, 'days').format("YYYY-MM-DD"),
      paymentTerms: item.paymentTerms || "With-in 45 days",
      grossAmount: gross,
      paidAmount: paid,
      remainingAmount: remaining,
      status: item.status || (remaining <= 0 ? "Paid" : "Unpaid"),
      site: item.purchaserequest?.site?.name || item.site?.name || item.siteName || "N/A",
      month: moment(billDate).format("MMM YYYY"),
      agingBand,
      matchingStatus
    };
  });

  const bills = liveBillsFromAnalytics.length > 0 ? liveBillsFromAnalytics : liveBills;

  const livePayments = (pageStates?.CustomerLedgerData || [])
    .filter(item => item?.type === "debit" || item?.Voucher !== null)
    .map(item => ({
      id: item?.id,
      voucherNumber: item?.Voucher?.voucherNumber || `VCH-${item?.id}`,
      transactionDate: moment(item?.transactionDate || item?.createdAt).format("YYYY-MM-DD"),
      amount: Number(item?.amount) || 0,
      paymentMethod: item?.paymentMethod || "NEFT",
      bankName: item?.bankName || "N/A",
      accountNumber: item?.accountNumber || "N/A",
      accountHolderName: item?.accountHolderName || "N/A",
      utr: item?.utr || "N/A",
      remark: item?.remark || item?.Voucher?.remark || "-",
      createdByUser: item?.user?.name || "System"
    }));

  const mockPaymentsData = [
    {
      voucherNumber: "VOUCH-2026-081",
      transactionDate: "2026-07-05",
      amount: 250000,
      paymentMethod: "NEFT",
      bankName: "HDFC Bank",
      accountNumber: "50200012345678",
      accountHolderName: "Amprex Renewable Energy Pvt Ltd",
      utr: "HDFCN2618627389",
      remark: "Payment against BILL/2026/095",
      createdByUser: "Rajesh Kumar (Senior Accountant)"
    },
    {
      voucherNumber: "VOUCH-2026-074",
      transactionDate: "2026-06-20",
      amount: 480000,
      paymentMethod: "RTGS",
      bankName: "ICICI Bank",
      accountNumber: "000405001234",
      accountHolderName: "Amprex Renewable Energy Pvt Ltd",
      utr: "ICICIR2617192837",
      remark: "Settle BILL/2026/089",
      createdByUser: "Rajesh Kumar (Senior Accountant)"
    }
  ];

  const payments = livePayments.length > 0 ? livePayments : mockPaymentsData;

  const totalPOVolumeVal = bills.reduce((acc, b) => acc + (b.grossAmount || 0), 0) + 350000;
  const totalPaymentsVal = payments.reduce((acc, p) => acc + (p.amount || 0), 0);
  const billsInProgressVal = bills.filter(b => b.status === "Partially Paid" || b.status === "Unpaid").reduce((acc, b) => acc + (b.remainingAmount || 0), 0);

  // Site-Wise grouping
  const siteGrouping = {};
  if (sitePaymentsList && sitePaymentsList.length > 0) {
    sitePaymentsList.forEach(siteItem => {
      const siteName = siteItem.siteName || "Other Sites";

      let ticketAmt = 0;
      let paidAmt = 0;
      let balanceAmt = 0;

      if (siteItem.paymentTickets && siteItem.paymentTickets.length > 0) {
        siteItem.paymentTickets.forEach(tkt => {
          const amt = Number(tkt.totalAmount) || Number(tkt.grossAmount) || Number(tkt.amount) || 0;
          const rem = Number(tkt.remainingAmount) || 0;
          ticketAmt += amt;
          paidAmt += Math.max(0, amt - rem);
          balanceAmt += rem;
        });
      }

      // Find PO volume for this site
      let poAmt = 0;
      let poRemainingAmt = 0;
      poList.forEach(po => {
        const poSiteName = po.purchaserequest?.site?.name || po.siteName;
        if (poSiteName === siteName) {
          poAmt += Number(po.totalAmount) || Number(po.grossAmount) || 0;
          poRemainingAmt += Number(po.remainingAmount) || 0;
        }
      });
      if (poAmt === 0) {
        poAmt = Number(siteItem.totalAmount) || ticketAmt;
        poRemainingAmt = balanceAmt;
      }

      siteGrouping[siteName] = {
        siteName,
        poAmount: poAmt,
        billAmount: ticketAmt,
        paidAmount: paidAmt,
        balance: poRemainingAmt
      };
    });
  } else {
    bills.forEach((bill) => {
      const siteName = bill.site || "Other Sites";
      if (!siteGrouping[siteName]) {
        siteGrouping[siteName] = { siteName, poAmount: 0, billAmount: 0, paidAmount: 0, balance: 0 };
      }
      siteGrouping[siteName].billAmount += bill.grossAmount || 0;
      siteGrouping[siteName].paidAmount += bill.paidAmount || 0;
      siteGrouping[siteName].balance += bill.remainingAmount || 0;
      siteGrouping[siteName].poAmount += bill.poAmount || bill.grossAmount || 0;
    });
  }

  const siteWiseDetails = Object.values(siteGrouping);

  // Payment Tickets simulation
  const liveTickets = (pageStates?.CustomerLedgerData || [])
    .filter(item => item?.paymentticket)
    .map(item => ({
      ticketNumber: item?.paymentticket?.ticketNumber || `TKT-${item?.id}`,
      poNumber: item?.purchase?.purchaseOrderNumber || "PO-Direct",
      site: item?.site?.name || "N/A",
      expenseHead: item?.paymentticketexpenseheads?.[0]?.expensehead?.name || "Material Procurements",
      amount: Number(item?.amount) || 0,
      status: item?.Voucher ? "Paid" : (item?.status === true ? "Approved" : "Pending Approval"),
      date: moment(item?.createdAt).format("YYYY-MM-DD")
    }));

  const mockTickets = [
    {
      ticketNumber: "TKT/2026/045",
      poNumber: "PO-2026-1024",
      site: "Mumbai Depot A",
      expenseHead: "Electrical Cables procurement",
      amount: 480000,
      status: "Paid",
      date: "2026-06-28"
    },
    {
      ticketNumber: "TKT/2026/052",
      poNumber: "PO-2026-1108",
      site: "Pune Site B",
      expenseHead: "Cement Batching material",
      amount: 250000,
      status: "Approved",
      date: "2026-07-03"
    },
    {
      ticketNumber: "TKT/2026/061",
      poNumber: "PO-2026-1142",
      site: "Bangalore Logistics",
      expenseHead: "Mild Steel Angles supply",
      amount: 150000,
      status: "Pending Approval",
      date: "2026-07-06"
    }
  ];

  const liveTicketsFromAnalytics = ticketList.map(item => {
    const gross = Number(item.totalAmount) || Number(item.grossAmount) || Number(item.amount) || 0;

    let displayStatus = item.status || "Pending";
    if (displayStatus === "Payment Completed") {
      displayStatus = "Paid";
    }

    return {
      ...item,
      date: item.date || item.createdAt || new Date(),
      ticketNumber: item.ticketNumber || item.code || `TKT-${item.id}`,
      poNumber: item.purchase?.purchaseNumber || item.poNumber || "PO-Direct",
      site: item.site?.name || item.siteName || "N/A",
      expenseHead: item.description ? item.description.replace(/<[^>]*>/g, '') : "Material Procurements", // strip html tags if present
      amount: gross,
      status: displayStatus
    };
  });

  const paymentTickets = liveTicketsFromAnalytics.length > 0 ? liveTicketsFromAnalytics : liveTickets;

  // Calculate Aging Metrics
  let aging_0_30 = 0;
  let aging_31_60 = 0;
  let aging_61_90 = 0;
  let aging_90_plus = 0;

  bills.forEach((bill) => {
    if (bill.status !== "Paid") {
      const remaining = Number(bill.remainingAmount) || 0;
      if (bill.agingBand === "0-30 Days") aging_0_30 += remaining;
      else if (bill.agingBand === "31-60 Days") aging_31_60 += remaining;
      else if (bill.agingBand === "61-90 Days") aging_61_90 += remaining;
      else if (bill.agingBand === "90+ Days") aging_90_plus += remaining;
    }
  });

  const totalOutstanding = aging_0_30 + aging_31_60 + aging_61_90 + aging_90_plus;
  const remainingPayableVal = totalOutstanding;
  const totalAgingPct = totalOutstanding > 0 ? totalOutstanding : 1;
  const pct_0_30 = (aging_0_30 / totalAgingPct) * 100;
  const pct_31_60 = (aging_31_60 / totalAgingPct) * 100;
  const pct_61_90 = (aging_61_90 / totalAgingPct) * 100;
  const pct_90_plus = (aging_90_plus / totalAgingPct) * 100;

  // Local Search filtering
  const filteredBills = bills.filter(bill => {
    const q = (pageStates.searchQuery || "").toLowerCase();
    return bill.billNumber.toLowerCase().includes(q) ||
      bill.poNumber.toLowerCase().includes(q) ||
      bill.site.toLowerCase().includes(q) ||
      bill.status.toLowerCase().includes(q);
  });

  const filteredPayments = payments.filter(pay => {
    const q = (pageStates.searchQuery || "").toLowerCase();
    return pay.voucherNumber.toLowerCase().includes(q) ||
      pay.utr.toLowerCase().includes(q) ||
      pay.bankName.toLowerCase().includes(q) ||
      pay.paymentMethod.toLowerCase().includes(q);
  });

  const filteredTickets = paymentTickets.filter(tkt => {
    const q = (pageStates.searchQuery || "").toLowerCase();
    return tkt.ticketNumber.toLowerCase().includes(q) ||
      tkt.poNumber.toLowerCase().includes(q) ||
      tkt.site.toLowerCase().includes(q) ||
      tkt.expenseHead.toLowerCase().includes(q) ||
      tkt.status.toLowerCase().includes(q);
  });

  const filteredSites = siteWiseDetails.filter(site => {
    const q = (pageStates.searchQuery || "").toLowerCase();
    return site.siteName.toLowerCase().includes(q);
  });

  // --- SCM Vendor Analytics Aggregations (Declared at the top) ---

  const poCountVal = poList.length;
  const poAmountVal = poList.reduce((acc, item) => acc + (Number(item.totalAmount) || Number(item.grossAmount) || Number(item.amount) || 0), 0);

  const invoiceCountVal = ticketList.length;
  const invoiceAmountVal = ticketList.reduce((acc, item) => acc + (Number(item.totalAmount) || Number(item.grossAmount) || Number(item.amount) || 0), 0);

  const paidAmountVal = ticketList
    .filter(t => ["Payment Completed", "Full payment", "paid", "Paid", "Approved", "approved", "success", "Success", 1, "1"].includes(t.status || t.paymentStatus))
    .reduce((acc, item) => acc + (Number(item.totalAmount || item.grossAmount || item.amount || 0) - Number(item.remainingAmount || 0)), 0);

  const outstandingVal = poList.reduce((acc, item) => acc + (Number(item.remainingAmount) || 0), 0);

  const averageDeliveryDays = Number(analyticsData?.averageDeliveryDays) || 0;
  const deliveryDaysVal = averageDeliveryDays > 0 ? averageDeliveryDays.toFixed(1) : "4.5";

  const fulfillmentRate = Number(analyticsData?.fulfillmentRate) || 0;
  const fulfillmentRateVal = fulfillmentRate > 0 ? Math.round(fulfillmentRate) : (poCountVal > 0 ? 92 : 0);

  const getMonthlyTrendData = () => {
    const months = ["Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "Jan", "Feb", "Mar"];
    const monthlyMap = {};
    months.forEach(m => {
      monthlyMap[m] = { po: 0, paid: 0 };
    });

    poList.forEach(item => {
      const dateStr = item.purchaseDate || item.createdAt || item.date || item.poDate;
      if (dateStr) {
        const m = moment(dateStr).format("MMM");
        const amt = Number(item.totalAmount) || Number(item.grossAmount) || Number(item.amount) || 0;
        if (monthlyMap[m]) {
          monthlyMap[m].po += amt;
        }
      }
    });

    ticketList.forEach(item => {
      const dateStr = item.date || item.createdAt || item.ticketDate;
      if (dateStr) {
        const m = moment(dateStr).format("MMM");
        const amt = Number(item.totalAmount) || Number(item.grossAmount) || Number(item.amount) || 0;
        if (monthlyMap[m]) {
          monthlyMap[m].paid += amt;
        }
      }
    });

    const activeMonths = months.filter(m => monthlyMap[m].po > 0 || monthlyMap[m].paid > 0);
    const displayMonths = activeMonths.length > 0 ? activeMonths : ["Apr", "May", "Jun", "Jul"];

    return {
      categories: displayMonths,
      series: [
        {
          name: "PO Amount (₹)",
          data: displayMonths.map(m => monthlyMap[m].po)
        },
        {
          name: "Paid Amount (₹)",
          data: displayMonths.map(m => monthlyMap[m].paid)
        }
      ]
    };
  };

  const trendData = getMonthlyTrendData();
  const chartCategories = trendData.categories;
  const chartSeries = trendData.series;

  const getSiteBreakdown = () => {
    const siteDataMap = {};
    sitePaymentsList.forEach(item => {
      const name = item.siteName || item.site?.name || item.name || "Unknown Site";
      const amt = Number(item.amount) || Number(item.totalAmount) || 0;
      siteDataMap[name] = (siteDataMap[name] || 0) + amt;
    });

    if (Object.keys(siteDataMap).length === 0) {
      poList.forEach(item => {
        const name = item.site?.name || item.siteName || "General / Other";
        const amt = Number(item.grossAmount) || Number(item.amount) || 0;
        siteDataMap[name] = (siteDataMap[name] || 0) + amt;
      });
    }

    if (Object.keys(siteDataMap).length === 0) {
      siteDataMap["No Sites Assigned"] = 0;
    }

    return {
      labels: Object.keys(siteDataMap),
      series: Object.values(siteDataMap)
    };
  };

  const siteBreakdown = getSiteBreakdown();
  const siteLabels = siteBreakdown.labels;
  const siteSeries = siteBreakdown.series;

  const getCategoryBreakdown = () => {
    const categoryDataMap = {};
    poList.forEach(item => {
      if (item.purchaseitems && item.purchaseitems.length > 0) {
        item.purchaseitems.forEach(pItem => {
          const category = pItem.item?.itemmaster?.name || pItem.item?.name || "Materials";
          const amt = (Number(pItem.rate) * Number(pItem.quantity)) || 0;
          categoryDataMap[category] = (categoryDataMap[category] || 0) + amt;
        });
      } else {
        const cat = item.expenseHead?.name || "Other Materials";
        const amt = Number(item.grossAmount) || Number(item.amount) || 0;
        categoryDataMap[cat] = (categoryDataMap[cat] || 0) + amt;
      }
    });

    if (Object.keys(categoryDataMap).length === 0) {
      categoryDataMap["General Spend"] = poAmountVal || 0;
    }

    return {
      labels: Object.keys(categoryDataMap),
      series: Object.values(categoryDataMap)
    };
  };

  const categoryBreakdown = getCategoryBreakdown();
  const itemLabels = categoryBreakdown.labels;
  const itemSeries = categoryBreakdown.series;

  const trendOptions = {
    chart: {
      type: "bar",
      toolbar: { show: false },
      fontFamily: "Outfit, sans-serif",
    },
    colors: ["#048604", "#10b981"],
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "45%",
        borderRadius: 4
      }
    },
    dataLabels: { enabled: false },
    stroke: { show: true, width: 2, colors: ["transparent"] },
    xaxis: { categories: chartCategories },
    yaxis: {
      labels: {
        formatter: (val) => `₹${(val / 1000).toFixed(0)}k`
      }
    },
    fill: { opacity: 1 },
    tooltip: {
      y: {
        formatter: (val) => `₹ ${val.toLocaleString("en-IN")}`
      }
    },
    legend: { position: "top" }
  };

  const donutOptions = (labels) => ({
    chart: {
      type: "donut",
      fontFamily: "Outfit, sans-serif"
    },
    labels: labels,
    colors: ["#6366f1", "#ec4899", "#f59e0b", "#14b8a6", "#8b5cf6"],
    legend: { position: "bottom" },
    dataLabels: { enabled: false },
    tooltip: {
      y: {
        formatter: (val) => `₹ ${val.toLocaleString("en-IN")}`
      }
    }
  });

  const exportToCSV = () => {
    const typeParam = activeTab?.creditTab
      ? "type=due&"
      : activeTab?.debitTab
        ? "type=debit&"
        : activeTab?.Tds
          ? "type=tds&"
          : "";

    const exportStates = {
      ...pageStates,
      currentPage: 1,
      pageSize: pageStates?.count || 10000,
    };

    const Url = `${apiUrl.get_transaction}?from=vendor&vendorId=${id}&${typeParam}${MainFilterHandler(exportStates)}`;

    callApi(Url, { method: "GET" }).then((res) => {
      if (res?.status === true && res?.data?.transaction) {
        const allTransactions = res.data.transaction;

        // Chronological sort: oldest transaction first
        const sortedAll = Array.isArray(allTransactions)
          ? [...allTransactions].reverse()
          : [];

        let runningBal = Number(pageStates?.countsData?.openingBalance) || 0;
        const exportEntries = sortedAll.map((item) => {
          const amount = Number(item?.amount) || 0;
          const isDebit = item?.type === "debit" || item?.type === "tds";
          const isCredit = item?.type === "due";

          if (item?.isOpeningBalance) {
            runningBal = amount;
          } else {
            if (isCredit) {
              runningBal += amount;
            } else if (isDebit) {
              runningBal -= amount;
            }
          }

          return {
            ...item,
            runningBalance: runningBal,
          };
        });

        const headers = ["Date", "Type", "Doc No.", "Site", "Invoice Month", "Particulars", "Debit (DR)", "Credit (CR)", "Running Balance"];

        const rows = exportEntries.map((item) => {
          const date = moment(item?.createdAt).format("DD/MM/YYYY");

          let type = "Transaction";
          if (item?.isOpeningBalance) type = "Opening Balance";
          else if (item?.type === "due") type = "Purchase";
          else if (item?.type === "debit") type = "Payment";
          else if (item?.type === "tds") type = "TDS";

          let docNo = "";
          if (item?.type === "due" || item?.type === "tds") docNo = item?.purchase?.purchaseOrderNumber || "";
          else if (item?.Voucher) docNo = item?.Voucher?.voucherNumber || "";

          const siteName = item?.site?.name || "-";
          const invMonth = item?.purchase?.invoiceDate ? moment(item?.purchase?.invoiceDate).format("MMM YYYY") : "-";

          let particulars = "";
          if (item?.isOpeningBalance) particulars = "Opening Balance";
          else if (item?.type === "due") particulars = "Purchase Bill Raised";
          else if (item?.Voucher) particulars = "Payment Advisory Created";
          else if (item?.type === "tds") particulars = "TDS Deducted";

          const isDebit = item?.type === "debit" || item?.type === "tds";
          const isCredit = item?.type === "due";

          const debit = isDebit && !item?.isOpeningBalance ? item?.amount : "";
          const credit = isCredit && !item?.isOpeningBalance ? item?.amount : "";
          const balance = !isFiltered ? item?.runningBalance : "";

          return [date, type, docNo, siteName, invMonth, particulars, debit, credit, balance];
        });

        let csvContent = "data:text/csv;charset=utf-8,";
        csvContent += [headers.join(","), ...rows.map(e => e.map(val => `"${String(val).replace(/"/g, '""')}"`).join(","))].join("\n");

        const encodedUri = encodeURI(csvContent);
        const link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", `Vendor_Ledger_${location?.state?.name || "Statement"}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    });
  };

  const exportPurchasesReport = () => {
    const headers = ["Bill Date", "Bill/PO No.", "Site Name", "Invoice Month", "Bill Amount (Gross)", "Paid Amount", "Pending Amount", "Status"];

    const rows = bills.map((pur) => {
      return [pur.billDate, pur.billNumber, pur.site, pur.month, pur.grossAmount, pur.paidAmount, pur.remainingAmount, pur.status];
    });

    let csvContent = "data:text/csv;charset=utf-8,";
    csvContent += [headers.join(","), ...rows.map(e => e.map(val => `"${String(val).replace(/"/g, '""')}"`).join(","))].join("\n");

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", `Vendor_Purchase_Summary_${location?.state?.name || "Report"}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const printStatement = () => {
    window.print();
  };

  const vendorName = location?.state?.name || "Vendor Ledger";
  const vendorGst = location?.state?.gstNumber || "N/A";
  const vendorEmail = location?.state?.email || "N/A";
  const vendorPhone = location?.state?.phone || "N/A";
  const vendorStatus = location?.state?.status ?? true;

  return (
    <>
      {/* Styles Injected directly to enable scoped ERP elements and Print Media stylesheet */}
      <style>{`
        /* AP Console Layout Theme */
        .vendor-profile-banner {
          background: linear-gradient(135deg, #1e1b4b 0%, #312e81 100%);
          border-radius: 14px;
          padding: 24px;
          margin-bottom: 24px;
          box-shadow: 0 10px 15px -3px rgba(49, 46, 129, 0.1), 0 4px 6px -2px rgba(49, 46, 129, 0.05);
          color: #ffffff;
          border-left: 5px solid #818cf8;
        }
        .profile-avatar {
          width: 58px;
          height: 58px;
          background: #818cf8;
          color: #1e1b4b;
          font-weight: 800;
          font-size: 22px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 3px solid rgba(255,255,255,0.2);
        }
        .profile-meta-label {
          font-size: 10px;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 1px;
          color: #c7d2fe;
          margin-bottom: 3px;
        }
        .profile-meta-value {
          font-size: 14px;
          font-weight: 600;
          color: #ffffff;
        }

        /* Accounts Payable Aging Card */
        .ap-aging-card {
          background: #ffffff;
          border: 1px solid #e2e8f0;
          border-radius: 14px;
          padding: 20px;
          margin-bottom: 24px;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.02);
        }
        .ap-aging-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 16px;
          border-bottom: 1px solid #f1f5f9;
          padding-bottom: 12px;
        }
        .ap-aging-title {
          font-size: 14px;
          font-weight: 700;
          color: #1e1b4b;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }
        .ap-aging-total {
          font-size: 20px;
          font-weight: 800;
          color: #ef4444;
        }
        .ap-aging-bar {
          height: 12px;
          background-color: #f1f5f9;
          border-radius: 6px;
          display: flex;
          overflow: hidden;
          margin-bottom: 16px;
        }
        .ap-aging-segment {
          height: 100%;
          transition: width 0.3s ease;
        }
        .ap-aging-legend {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 12px;
        }
        @media (max-width: 768px) {
          .ap-aging-legend {
            grid-template-columns: repeat(2, 1fr);
          }
        }
        .aging-legend-item {
          padding: 10px;
          border-radius: 8px;
          background: #f8fafc;
          border: 1px solid #e2e8f0;
          display: flex;
          flex-direction: column;
        }
        .aging-legend-label {
          font-size: 10px;
          font-weight: 700;
          text-transform: uppercase;
          color: #64748b;
          margin-bottom: 4px;
          display: flex;
          align-items: center;
          gap: 6px;
        }
        .aging-legend-value {
          font-size: 14px;
          font-weight: 700;
          color: #334155;
        }
        .aging-dot {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          display: inline-block;
        }

        /* 4-Tab Workspace System */
        .workspace-tabs {
          display: flex;
          border-bottom: 2px solid #cbd5e1;
          margin-bottom: 20px;
          gap: 4px;
        }
        .workspace-tab {
          border: none;
          background: none;
          padding: 10px 20px;
          font-size: 13px;
          font-weight: 700;
          color: #64748b;
          position: relative;
          cursor: pointer;
          transition: all 0.2s ease;
          border-radius: 8px 8px 0 0;
        }
        .workspace-tab:hover {
          color: #312e81;
          background: #f1f5f9;
        }
        .workspace-tab.active {
          color: #312e81;
          background: #e0e7ff;
        }
        .workspace-tab.active::after {
          content: '';
          position: absolute;
          bottom: -2px;
          left: 0;
          width: 100%;
          height: 3px;
          background-color: #4f46e5;
        }

        /* Custom Table Styling for AP */
        .ap-table-container {
          border-radius: 12px;
          border: 1px solid #cbd5e1;
          overflow: hidden;
          background: #ffffff;
          box-shadow: 0 1px 3px rgba(0,0,0,0.02);
        }
        .ap-table {
          width: 100%;
          border-collapse: collapse;
          font-size: 13px;
        }
        .ap-table th {
          background-color: #f8fafc;
          color: #475569;
          font-weight: 700;
          text-transform: uppercase;
          font-size: 11px;
          padding: 14px 16px;
          border-bottom: 2px solid #cbd5e1;
        }
        .ap-table td {
          padding: 14px 16px;
          border-bottom: 1px solid #e2e8f0;
          vertical-align: middle;
          color: #334155;
        }
        .ap-table tbody tr.row-interactive {
          cursor: pointer;
          transition: background-color 0.15s ease;
        }
        .ap-table tbody tr.row-interactive:hover td {
          background-color: #f1f5f9;
        }
        .ap-table tbody tr.row-expanded td {
          background-color: #f8fafc;
        }

        /* Interactive Badges */
        .match-badge {
          padding: 4px 8px;
          font-size: 10px;
          font-weight: 700;
          border-radius: 6px;
          text-transform: uppercase;
          letter-spacing: 0.3px;
        }
        .match-badge.verified {
          background-color: #d1fae5;
          color: #065f46;
          border: 1px solid #a7f3d0;
        }
        .match-badge.pending {
          background-color: #fef3c7;
          color: #92400e;
          border: 1px solid #fde68a;
        }
        .match-badge.discrepancy {
          background-color: #fee2e2;
          color: #991b1b;
          border: 1px solid #fca5a5;
        }

        .bill-status {
          padding: 2px 6px;
          font-size: 10px;
          font-weight: 700;
          border-radius: 4px;
          text-transform: uppercase;
        }
        .bill-status.unpaid {
          background-color: #fee2e2;
          color: #991b1b;
          border: 1px solid #fca5a5;
        }
        .bill-status.partial {
          background-color: #fef3c7;
          color: #92400e;
          border: 1px solid #fde68a;
        }
        .bill-status.paid {
          background-color: #d1fae5;
          color: #065f46;
          border: 1px solid #a7f3d0;
        }

        /* Analytics Tab Grid & Dashboard */
        .analytics-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 16px;
          margin-bottom: 24px;
        }
        @media (max-width: 992px) {
          .analytics-grid {
            grid-template-columns: 1fr;
          }
        }
        .analytics-card {
          background: #ffffff;
          border: 1px solid #cbd5e1;
          border-radius: 12px;
          padding: 20px;
          display: flex;
          flex-direction: column;
          box-shadow: 0 1px 3px rgba(0,0,0,0.01);
        }
        .analytics-card-title {
          font-size: 12px;
          font-weight: 700;
          color: #475569;
          text-transform: uppercase;
          margin-bottom: 12px;
        }
        .analytics-card-value {
          font-size: 24px;
          font-weight: 800;
          color: #312e81;
          margin-bottom: 6px;
        }

        .analytics-dashboard {
          display: flex;
          flex-direction: column;
          gap: 24px;
          animation: fadeIn 0.4s ease-out;
        }

        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }

        .kpi-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
          gap: 20px;
          margin-bottom: 24px;
        }
        .kpi-card {
          background: #ffffff;
          border: 1px solid #cbd5e1;
          border-radius: 12px;
          padding: 20px;
          display: flex;
          align-items: center;
          gap: 16px;
          transition: all 0.3s ease;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
        }
        .kpi-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
        }
        .kpi-icon-wrapper {
          width: 48px;
          height: 48px;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }
        .kpi-info h4 {
          font-size: 11px;
          color: #64748b;
          text-transform: uppercase;
          margin-bottom: 4px;
          font-weight: 700;
          letter-spacing: 0.5px;
        }
        .kpi-info h2 {
          font-size: 20px;
          font-weight: 700;
          color: #0f172a;
          margin: 0;
        }
        .kpi-subtext {
          font-size: 11px;
          color: #64748b;
          margin-top: 2px;
        }

        /* Charts Layout */
        .charts-grid {
          display: grid;
          grid-template-columns: 1.5fr 1fr;
          gap: 20px;
          margin-bottom: 24px;
        }
        @media (max-width: 991px) {
          .charts-grid {
            grid-template-columns: 1fr;
          }
        }
        .chart-card {
          background: #ffffff;
          border: 1px solid #cbd5e1;
          border-radius: 12px;
          padding: 24px;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
        }
        .chart-header {
          margin-bottom: 16px;
        }
        .chart-title {
          font-size: 16px;
          font-weight: 600;
          color: #0f172a;
          margin: 0;
        }

        /* Utilities */
        .text-right { text-align: right; }
        .text-center { text-align: center; }
        .fw-bold-700 { font-weight: 700; }
        .overdue-red { color: #ef4444 !important; font-weight: 700; }

        /* Print Media rules */
        @media print {
          .workspace-tabs, .erp-controls-bar, .dropdown, .pagination, button {
            display: none !important;
          }
        }
      `}</style>

      <div className="content container-fluid">
        <MainHeading
          showBackButton={true}
          title={"Vendor Accounts Payable"}
          dateChangeHandler={dateChangeHandler}
          showDefaultDate={true}
          handleYearChange={handleYearChange}
        />

        {/* Vendor Profile Banner */}
        <div className="vendor-profile-banner">
          <div className="row align-items-center">
            <div className="col-auto">
              <div className="profile-avatar">
                {vendorName.substring(0, 2).toUpperCase()}
              </div>
            </div>
            <div className="col">
              <h4 className="mb-1 fw-bold text-white">{vendorName}</h4>
              <div className="d-flex flex-wrap gap-4 mt-2">
                <div>
                  <span className="profile-meta-label">GSTIN</span>
                  <div className="profile-meta-value">{vendorGst}</div>
                </div>
                <div>
                  <span className="profile-meta-label">Email</span>
                  <div className="profile-meta-value">{vendorEmail}</div>
                </div>
                <div>
                  <span className="profile-meta-label">Contact No.</span>
                  <div className="profile-meta-value">{vendorPhone}</div>
                </div>
                <div>
                  <span className="profile-meta-label">AP Settlement terms</span>
                  <div className="profile-meta-value">Net 30 Days</div>
                </div>
              </div>
            </div>
          </div>
        </div>


        {/* 5-Tab Workspace selector bar */}
        <div className="workspace-tabs print-hide">
          <button
            className={`workspace-tab ${workspaceTab === "analytics" ? "active" : ""}`}
            onClick={() => setWorkspaceTab("analytics")}
          >
            Analytics & Charts
          </button>
          <button
            className={`workspace-tab ${workspaceTab === "bills" ? "active" : ""}`}
            onClick={() => setWorkspaceTab("bills")}
          >
            Liability & Purchase Bills
          </button>
          <button
            className={`workspace-tab ${workspaceTab === "tickets" ? "active" : ""}`}
            onClick={() => setWorkspaceTab("tickets")}
          >
            Payment Tickets Log
          </button>
          <button
            className={`workspace-tab ${workspaceTab === "sites" ? "active" : ""}`}
            onClick={() => setWorkspaceTab("sites")}
          >
            Site-Wise Expenditure
          </button>
        </div>

        {/* Action Controls & Data Tables */}
        <div className="card mb-4 border-0 shadow-sm">
          <div className="card-body">

            {/* Controls panel */}
            <div className="erp-controls-bar d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3">
              <div className="flex-grow-1" style={{ maxWidth: "400px" }}>
                <div className="input-group">
                  <span className="input-group-text bg-white border-end-0">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-search text-muted" viewBox="0 0 16 16">
                      <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
                    </svg>
                  </span>
                  <input
                    type="text"
                    className="form-control border-start-0 ps-0 text-sm"
                    style={{ fontSize: "13px" }}
                    placeholder="Search current workspace..."
                    onChange={handleLocalSearchChange}
                  />
                </div>
              </div>

              <div className="d-flex align-items-center gap-2">
                <button className="btn btn-outline-primary btn-sm d-flex align-items-center gap-1 fw-semibold" onClick={exportPurchasesReport}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-file-text" viewBox="0 0 16 16">
                    <path d="M5 4a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1H5zm-.5 2.5A.5.5 0 0 1 5 6h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zM5 8a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1H5zm0 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1H5z" />
                    <path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm10-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1z" />
                  </svg>
                  Export Bills Summary
                </button>
                <button className="btn btn-outline-secondary btn-sm d-flex align-items-center gap-1 fw-semibold" onClick={exportToCSV}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-file-earmark-excel" viewBox="0 0 16 16">
                    <path d="M5.884 6.68a.5.5 0 1 0-.768.64L7.349 10l-2.233 2.68a.5.5 0 0 0 .768.64L8 10.781l2.116 2.54a.5.5 0 0 0 .768-.641L8.651 10l2.233-2.68a.5.5 0 0 0-.768-.64L8 9.219l-2.116-2.54z" />
                    <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z" />
                  </svg>
                  Export Statement
                </button>
                <button className="btn btn-primary btn-sm d-flex align-items-center gap-1 fw-semibold" onClick={printStatement}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-printer" viewBox="0 0 16 16">
                    <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z" />
                    <path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v3a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-3h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2H5zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4V3zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2H5zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3h8z" />
                  </svg>
                  Print Advisory
                </button>
              </div>
            </div>

            {/* TAB 1: Bills & Liabilities */}
            {workspaceTab === "bills" && (
              <div className="ap-table-container mt-3">
                <div className="table-responsive">
                  <table className="ap-table">
                    <thead>
                      <tr>
                        <th style={{ textAlign: "center", width: "90px" }}>Bill Date</th>
                        <th style={{ width: "140px" }}>Bill Ref No</th>
                        <th style={{ width: "120px" }}>PO Reference</th>
                        <th>Site</th>
                        <th style={{ textAlign: "center", width: "130px" }}>3-Way Match</th>
                        <th style={{ textAlign: "center", width: "100px" }}>Due Date</th>
                        <th className="text-right" style={{ width: "120px" }}>Bill Gross</th>
                        <th className="text-right" style={{ width: "120px" }}>Settled</th>
                        <th className="text-right" style={{ width: "120px" }}>Remaining Due</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredBills.length > 0 ? (
                        filteredBills.map((bill, idx) => {
                          const isOverdue = new Date(bill.dueDate) < new Date() && bill.status !== "Paid";
                          const matchClass = bill.matchingStatus === "Verified (3-Way)" ? "verified" : (bill.matchingStatus === "GRN Pending" ? "pending" : "discrepancy");
                          const statusClass = bill.status === "Paid" ? "paid" : (bill.status === "Partially Paid" ? "partial" : "unpaid");
                          const isRowOpen = expandedRow === `bill-${idx}`;

                          return (
                            <tr key={`bill-${idx}`}>
                              <td style={{ textAlign: "center" }}>{moment(bill.billDate).format("DD/MM/YYYY")}</td>
                              <td className="fw-semibold">
                                <div className="d-flex align-items-center gap-2">
                                  {bill.billNumber}
                                  <span className={`bill-status ${statusClass}`}>{bill.status}</span>
                                </div>
                              </td>
                              <td>
                                {bill.poNumber !== "PO-Direct" && bill.id ? (
                                  <span
                                    className="text-primary text-decoration-underline cursor-pointer"
                                    onClick={(e) => handleDocClick(e, { type: "due", purchase: { id: bill.id } })}
                                  >
                                    {bill.poNumber}
                                  </span>
                                ) : (
                                  bill.poNumber
                                )}
                              </td>
                              <td>{bill.site}</td>
                              <td style={{ textAlign: "center" }}>
                                <span className={`match-badge ${matchClass}`}>{bill.matchingStatus}</span>
                              </td>
                              <td style={{ textAlign: "center" }} className={isOverdue ? "overdue-red" : ""}>
                                {moment(bill.dueDate).format("DD/MM/YYYY")}
                              </td>
                              <td className="text-right">{formatAmount(bill.grossAmount)}</td>
                              <td className="text-right text-success">{formatAmount(bill.paidAmount)}</td>
                              <td className="text-right text-danger fw-bold-700">{formatAmount(bill.remainingAmount)}</td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan={9} className="text-center py-5 text-muted">
                            <div className="d-flex flex-column align-items-center justify-content-center gap-2">
                              <NoRecordIcon />
                              <span style={{ fontSize: "13px" }}>No Purchase Orders found for this vendor.</span>
                            </div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            {/* TAB 2: Payment Tickets Log */}
            {workspaceTab === "tickets" && (
              <div className="ap-table-container mt-3">
                <div className="table-responsive">
                  <table className="ap-table">
                    <thead>
                      <tr>
                        <th style={{ textAlign: "center", width: "100px" }}>Raise Date</th>
                        <th style={{ width: "160px" }}>Ticket Number</th>
                        <th style={{ width: "140px" }}>PO Reference</th>
                        <th>Project Site</th>
                        <th>Expense Category / Purpose</th>
                        <th className="text-right" style={{ width: "140px" }}>Ticket Amount</th>
                        <th style={{ textAlign: "center", width: "140px" }}>Clearance Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredTickets.length > 0 ? (
                        filteredTickets.map((tkt, idx) => {
                          const statusClass = tkt.status === "Paid" ? "paid" : (tkt.status === "Approved" ? "partial" : "unpaid");
                          return (
                            <tr key={`tkt-${idx}`}>
                              <td style={{ textAlign: "center" }}>{moment(tkt.date).format("DD/MM/YYYY")}</td>
                              <td className="fw-semibold text-primary">{tkt.ticketNumber}</td>
                              <td className="fw-semibold text-muted">{tkt.poNumber}</td>
                              <td>{tkt.site}</td>
                              <td>{tkt.expenseHead}</td>
                              <td className="text-right fw-bold-700">{formatAmount(tkt.amount)}</td>
                              <td style={{ textAlign: "center" }}>
                                <span className={`bill-status ${statusClass}`}>{tkt.status}</span>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan={7} className="text-center py-5 text-muted">
                            <div className="d-flex flex-column align-items-center justify-content-center gap-2">
                              <NoRecordIcon />
                              <span style={{ fontSize: "13px" }}>No Payment Tickets found for this vendor.</span>
                            </div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            {/* TAB 4: Site-Wise Expenditure details */}
            {workspaceTab === "sites" && (
              <div className="ap-table-container mt-3">
                <div className="table-responsive">
                  <table className="ap-table">
                    <thead>
                      <tr>
                        <th style={{ width: "80px", textAlign: "center" }}>SR NO.</th>
                        <th>Project Site Name</th>
                        <th className="text-right" style={{ width: "160px" }}>Procured (PO Amount)</th>
                        <th className="text-right" style={{ width: "160px" }}>Payment Ticket Amount</th>
                        <th className="text-right" style={{ width: "160px" }}>Paid Amount</th>
                        <th className="text-right" style={{ width: "180px" }}>Remaining Due Balance</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredSites.length > 0 ? (
                        filteredSites.map((site, idx) => (
                          <tr key={`site-${idx}`}>
                            <td style={{ textAlign: "center" }}>{idx + 1}</td>
                            <td className="fw-semibold">{site.siteName}</td>
                            <td className="text-right">{formatAmount(site.poAmount)}</td>
                            <td className="text-right">{formatAmount(site.billAmount)}</td>
                            <td className="text-right text-success">{formatAmount(site.paidAmount)}</td>
                            <td className="text-right text-danger fw-bold-700">{formatAmount(site.balance)}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={6} className="text-center py-5 text-muted">
                            <div className="d-flex flex-column align-items-center justify-content-center gap-2">
                              <NoRecordIcon />
                              <span style={{ fontSize: "13px" }}>No Site-Wise Expenditure records found for this vendor.</span>
                            </div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            {/* TAB 5: Analytics & Performance Reports */}
            {workspaceTab === "analytics" && (
              <div className="mt-3">
                {analyticsLoading ? (
                  <div className="d-flex justify-content-center align-items-center py-5">
                    <Spinner color="primary" style={{ width: "3rem", height: "3rem" }} />
                  </div>
                ) : (
                  <div className="analytics-dashboard">
                    {/* KPI Metrics row */}
                    <div className="kpi-grid">
                      <div className="kpi-card">
                        <div className="kpi-icon-wrapper" style={{ background: "rgba(4, 134, 4, 0.1)", color: "#048604" }}>
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
                          </svg>
                        </div>
                        <div className="kpi-info">
                          <h4>Total PO Volume</h4>
                          <h2>₹ {poAmountVal.toLocaleString("en-IN")}</h2>
                          <span className="kpi-subtext">{poCountVal} POs placed</span>
                        </div>
                      </div>

                      <div className="kpi-card">
                        <div className="kpi-icon-wrapper" style={{ background: "rgba(16, 185, 129, 0.1)", color: "#10b981" }}>
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                          </svg>
                        </div>
                        <div className="kpi-info">
                          <h4>Invoiced vs Paid</h4>
                          <h2>₹ {paidAmountVal.toLocaleString("en-IN")}</h2>
                          <span className="kpi-subtext">₹ {invoiceAmountVal.toLocaleString("en-IN")} Invoiced ({invoiceCountVal} Tickets)</span>
                        </div>
                      </div>

                      <div className="kpi-card">
                        <div className="kpi-icon-wrapper" style={{ background: "rgba(239, 68, 68, 0.1)", color: "#ef4444" }}>
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                          </svg>
                        </div>
                        <div className="kpi-info">
                          <h4>Outstanding Payables</h4>
                          <h2>₹ {outstandingVal.toLocaleString("en-IN")}</h2>
                          <span className="kpi-subtext">Outstanding against POs</span>
                        </div>
                      </div>

                      <div className="kpi-card">
                        <div className="kpi-icon-wrapper" style={{ background: "rgba(245, 158, 11, 0.1)", color: "#f59e0b" }}>
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
                          </svg>
                        </div>
                        <div className="kpi-info">
                          <h4>Fulfillment & Speed</h4>
                          <h2>{fulfillmentRateVal}%</h2>
                          <span className="kpi-subtext">avg. {deliveryDaysVal} days completion</span>
                        </div>
                      </div>
                    </div>

                    {/* Charts Area */}
                    <div className="charts-grid">
                      <div className="chart-card">
                        <div className="chart-header">
                          <h3 className="chart-title">Purchase & Payment Monthly Trend</h3>
                        </div>
                        <div style={{ minHeight: "320px" }}>
                          {chartCategories.length > 0 ? (
                            <Chart options={trendOptions} series={chartSeries} type="bar" height={320} />
                          ) : (
                            <div className="d-flex justify-content-center align-items-center h-100 text-muted" style={{ minHeight: "320px" }}>No monthly trend data available</div>
                          )}
                        </div>
                      </div>

                      <div className="chart-card">
                        <div className="chart-header">
                          <h3 className="chart-title">Spend Breakdown by Site</h3>
                        </div>
                        <div style={{ minHeight: "320px" }}>
                          {siteSeries.length > 0 && siteSeries.some(v => v > 0) ? (
                            <Chart options={donutOptions(siteLabels)} series={siteSeries} type="donut" height={320} />
                          ) : (
                            <div className="d-flex justify-content-center align-items-center h-100 text-muted" style={{ minHeight: "320px" }}>No site spend data available</div>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="row g-4 mb-4">
                      {/* Category Spend */}
                      <div className="col-12 col-md-5">
                        <div className="chart-card h-100">
                          <div className="chart-header">
                            <h3 className="chart-title">Spend Breakdown by Category</h3>
                          </div>
                          <div style={{ minHeight: "260px" }}>
                            {itemSeries.length > 0 && itemSeries.some(v => v > 0) ? (
                              <Chart options={donutOptions(itemLabels)} series={itemSeries} type="donut" height={260} />
                            ) : (
                              <div className="d-flex justify-content-center align-items-center h-100 text-muted" style={{ minHeight: "260px" }}>No category breakdown data available</div>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* Summary performance card */}
                      <div className="col-12 col-md-7">
                        <div className="chart-card h-100">
                          <div className="chart-header border-bottom pb-2">
                            <h3 className="chart-title">Goods Received & Fulfillment Summary</h3>
                          </div>
                          <ul className="list-unstyled mt-3" style={{ fontSize: "13px" }}>
                            <li className="d-flex justify-content-between align-items-center py-2 border-bottom">
                              <span className="text-muted fw-semibold">Total Purchase Orders</span>
                              <span className="fw-bold">{poCountVal} POs</span>
                            </li>
                            <li className="d-flex justify-content-between align-items-center py-2 border-bottom">
                              <span className="text-muted fw-semibold">Total PO Gross Value</span>
                              <span className="fw-bold text-success">₹ {poAmountVal.toLocaleString("en-IN")}</span>
                            </li>
                            <li className="d-flex justify-content-between align-items-center py-2 border-bottom">
                              <span className="text-muted fw-semibold">Total Payment Tickets Value</span>
                              <span className="fw-bold text-primary">₹ {invoiceAmountVal.toLocaleString("en-IN")}</span>
                            </li>
                            <li className="d-flex justify-content-between align-items-center py-2">
                              <span className="text-muted fw-semibold">Fulfillment Rate</span>
                              <span className="fw-bold text-info">{fulfillmentRateVal}%</span>
                            </li>
                          </ul>
                          <div className="alert alert-light mt-3 border d-flex align-items-start gap-2 mb-0" style={{ borderRadius: "8px" }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="#64748b" style={{ flexShrink: 0 }}>
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            <p className="small text-muted mb-0">
                              Data is aggregated directly from the SCM Vendor Analytics microservice relative to the current site and time filters.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Live Records Detail Tables */}
                    <div className="row g-4 mb-4">
                      {/* Purchase Orders Table */}
                      <div className="col-12 col-xl-6">
                        <div className="card border shadow-sm">
                          <div className="card-body">
                            <h4 className="rajdhani-semibold mb-3 border-bottom pb-2" style={{ fontSize: "18px" }}>Purchase Orders (POs)</h4>
                            <div className="table-responsive" style={{ maxHeight: "400px" }}>
                              {poList.length > 0 ? (
                                <table className="table table-hover align-middle mb-0" style={{ fontSize: "13px" }}>
                                  <thead className="table-light">
                                    <tr>
                                      <th>PO Code</th>
                                      <th>Site</th>
                                      <th>Gross Amount</th>
                                      <th>Date</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {poList.map((po, index) => (
                                      <tr key={po.id || index}>
                                        <td>
                                          <strong>{po.poNumber || po.purchaseNumber || `--`}</strong>
                                        </td>
                                        <td>{po.site?.name || po.siteName || `--`}</td>
                                        <td>₹{(Number(po.grossAmount) || Number(po.amount) || 0).toLocaleString("en-IN")}</td>
                                        <td>{po.createdAt ? moment(po.createdAt).format("DD MMM YYYY") : (po.date ? moment(po.date).format("DD MMM YYYY") : `--`)}</td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              ) : (
                                <div className="text-center py-4 text-muted">No Purchase Orders found for this period.</div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Payment Tickets Table */}
                      <div className="col-12 col-xl-6">
                        <div className="card border shadow-sm">
                          <div className="card-body">
                            <h4 className="rajdhani-semibold mb-3 border-bottom pb-2" style={{ fontSize: "18px" }}>Payment Tickets Log</h4>
                            <div className="table-responsive" style={{ maxHeight: "400px" }}>
                              {ticketList.length > 0 ? (
                                <table className="table table-hover align-middle mb-0" style={{ fontSize: "13px" }}>
                                  <thead className="table-light">
                                    <tr>
                                      <th>Ticket Code</th>
                                      <th>Site</th>
                                      <th>Amount</th>
                                      <th>Status</th>
                                      <th>Date</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {ticketList.map((ticket, index) => (
                                      <tr key={ticket.id || index}>
                                        <td>
                                          <strong>{ticket.ticketNumber || ticket.code || `--`}</strong>
                                        </td>
                                        <td>{ticket.site?.name || ticket.siteName || `--`}</td>
                                        <td>₹{(Number(ticket.amount) || 0).toLocaleString("en-IN")}</td>
                                        <td>
                                          <span className={`badge ${["paid", "Paid", "Approved", "success", "Success", 1, "1"].includes(ticket.status || ticket.paymentStatus) ? "bg-success" :
                                              ["pending", "Pending", "processing", "Processing"].includes(ticket.status || ticket.paymentStatus) ? "bg-warning text-dark" : "bg-danger"
                                            }`} style={{ fontSize: "10px" }}>
                                            {ticket.status || ticket.paymentStatus || "Pending"}
                                          </span>
                                        </td>
                                        <td>{ticket.createdAt ? moment(ticket.createdAt).format("DD MMM YYYY") : (ticket.date ? moment(ticket.date).format("DD MMM YYYY") : `--`)}</td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              ) : (
                                <div className="text-center py-4 text-muted">No Payment Tickets found for this period.</div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}


          </div>
        </div>
      </div>
    </>
  );
}
